/* eslint-disable react/prop-types */
import React from 'react';
import { ZCDCard, ZCDFlex, ZCDIcon, ZCDSpacer } from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

// eslint-disable-next-line complexity, max-lines-per-function
function TopicAnalysisCard({
  topic,
  color,
  colorIndex,
  filters,
  expanded,
  isReportBuilder,
  dispatchTopicAnalysis,
}) {
  const { t } = useTranslation();
  const onSelect = (name) => {
    if (dispatchTopicAnalysis) {
      dispatchTopicAnalysis({ type: 'select', payload: name });
    }
  };
  const numberOfSubtopics = (topic.subtopics && topic.subtopics.length) || 0;
  const isExpanded = expanded.includes(topic.name);
  const isSelected = filters.includes(topic.name);
  return (
    <div
      onClick={() => {
        onSelect(topic.name);
      }}
      data-testid={`topiccard-${topic.name}`}
    >
      <ZCDCard
        className={`engage-topic-result-card color-${colorIndex} ${isSelected && 'selected'}`}
      >
        <ZCDFlex style={{ gap: '1rem' }}>
          <div
            className={classNames(
              'engage-topic-col-main',
              isReportBuilder && 'engage-topic-col-main-report-builder'
            )}
          >
            <span className={classNames('engage-topic-name')}>{topic.name}</span>
            <ZCDSpacer size="xsmall" orientation="vertical" />
            {/** percentage bar */}
            <div className={classNames('engage-topic-percentage-bar-background')}>
              <div
                className={classNames('engage-topic-percentage-bar-foreground')}
                style={{ width: `${topic.percentage}%`, backgroundColor: color }}
              />
            </div>
          </div>
          <div className={classNames('engage-topic-col-info')}>
            {numberOfSubtopics > 0 ? (
              <>{t('topicAnalysis.subTopics', { count: numberOfSubtopics })}</>
            ) : (
              <br />
            )}
            <ZCDSpacer size="xsmall" orientation="vertical" />
            <div>
              <span className={classNames('engage-topic-statistic')}>
                {t('topicAnalysis.responseCount', { count: topic.count })}
              </span>
              <span className={classNames('engage-topic-statistic')}>
                {t('topicAnalysis.percentage', { percentage: topic.percentage })}
              </span>
            </div>
          </div>
          {!isReportBuilder && (
            <div className={classNames('engage-topic-col-expand')}>
              {topic.subtopics && topic.subtopics.length > 0 && (
                <div
                  onClick={(event) => {
                    if (dispatchTopicAnalysis) {
                      dispatchTopicAnalysis({ type: 'toggleExpand', payload: topic.name });
                    }
                    event.stopPropagation();
                  }}
                  data-testid={`topic-expand-${topic.name}`}
                >
                  {!isExpanded && <ZCDIcon name="chevron-right" color={'zcd-blue-50'} />}
                  {isExpanded && <ZCDIcon name="chevron-down" color={'zcd-blue-50'} />}
                </div>
              )}
            </div>
          )}
        </ZCDFlex>
        {!isReportBuilder && (
          <div className={classNames('engage-subtopic-container')}>
            <div
              className={classNames(
                'engage-subtopic-expand',
                isExpanded && 'engage-subtopic-expanded'
              )}
            >
              {topic.subtopics &&
                topic.subtopics.length > 0 &&
                topic.subtopics.map((subtopic) => {
                  const isSubtopicSelected = filters.includes(subtopic.name);
                  return (
                    <div
                      onClick={(event) => {
                        onSelect(subtopic.name);
                        event.stopPropagation();
                      }}
                      data-testid={`subtopiccard-${subtopic.name}`}
                      key={subtopic.name}
                    >
                      <ZCDCard
                        className={classNames(
                          'engage-subtopic-card',
                          isSubtopicSelected && 'selected'
                        )}
                      >
                        <div className={classNames('engage-topic-result-card-head')}>
                          <ZCDFlex justifyContent="space-between">
                            <div
                              className={classNames(
                                'engage-topic-col-main',
                                'engage-subtopic-name'
                              )}
                            >
                              {subtopic.name}
                            </div>
                            <div>
                              <span className={classNames('engage-topic-statistic')}>
                                {t('topicAnalysis.responseCount', { count: subtopic.count })}
                              </span>
                              <span className={classNames('engage-topic-statistic')}>
                                {t('topicAnalysis.percentage', { percentage: subtopic.percentage })}
                              </span>
                            </div>
                          </ZCDFlex>
                        </div>
                      </ZCDCard>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </ZCDCard>
    </div>
  );
}

export default TopicAnalysisCard;
